export default __webpack_public_path__ + "static/burred-cca183d7d6e05e88770fb40a13cc13f2.png";